<script setup lang="ts">
type TaskData = App.Tasks.Data.TaskData;

import TaskSquare from './TaskSquare.vue';
import { formatRelative } from '@/utils/date';

const props = defineProps<{
  task: TaskData;
}>();

const label = computed((): string => {
  if (props.task.status.value === 'incomplete') {
    return props.task.due_date ? 'Due ' + formatRelative(props.task.due_date, 'MMMM d') : '';
  }
  if (
    props.task.status.value === 'rejection_dismissed' &&
    props.task.data_request?.status.value === 'rejected'
  ) {
    return 'Submission not approved';
  }
  return '';
});

const labelStyle = computed((): string => {
  const isRejected = props.task.status.value === 'rejected';
  const rejectedDataRequestDismissed =
    props.task.status.value === 'rejection_dismissed' &&
    props.task.data_request?.status.value === 'rejected';
  const isOverdue = props.task.due_date && props.task.due_date < new Date().toISOString();

  if (isRejected || isOverdue || rejectedDataRequestDismissed) {
    return 'text-red-600';
  }

  return '';
});
</script>

<template>
  <div class="flex items-center gap-4">
    <TaskSquare :task="task" />
    <div>
      <div class="font-semibold leading-snug text-slate-900">{{ task.title }}</div>
      <div class="text-xs" :class="labelStyle">
        {{ label }}
      </div>
    </div>
  </div>
</template>
